import { Button } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Field, Form, formValueSelector, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'
import { TWO_FACTOR } from 'modules/Auth/types'
import { CODE_LENGTH, validationSchema } from 'modules/Forms/Auth/DoubleFA/validationSchema'
import renderNumericSegmentedField from 'components/FormControls/numericSegmentedInput'

let DoubleFAForm = ({ handleSubmit, submitting, form, reset }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const selector = formValueSelector(form)
  const [autoFocus, setAutoFocus] = useState(true)

  const { code } = useSelector((state) => ({ code: selector(state, 'code') }))

  const submit = async (values) =>
    new Promise((resolve, reject) => {
      dispatch({
        meta: { resolve, reject },
        type: TWO_FACTOR,
        payload: {
          data: { ...values },
          formName: form,
        },
      })
    }).catch(() => {
      reset()
      setAutoFocus(true)
    })

  useEffect(() => {
    if (code.length === CODE_LENGTH) {
      setAutoFocus(false)
      handleSubmit()
    }
  }, [code])

  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Field
        fullWidth
        name="code"
        type="text"
        inputMode="numeric"
        autoFocus={autoFocus}
        component={renderNumericSegmentedField}
        normalize={onlyNumbers}
        autoComplete="off"
        length={CODE_LENGTH}
        t={t}
      />

      <Button
        style={{ display: 'none' }}
        fullWidth
        disabled={submitting}
        size="l"
        variant="primary"
        type="submit"
      >
        {t('common::buttons.login')}
      </Button>
    </Form>
  )
}

DoubleFAForm = reduxForm({
  form: 'DoubleFAForm',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    code: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(DoubleFAForm)

DoubleFAForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
  onCancel: PropTypes.func,
  reset: PropTypes.func,
}

DoubleFAForm.defaultValues = {
  handleSubmit: () => {},
  submitting: false,
  form: 'DoubleFAForm',
}

export default DoubleFAForm
